module.exports = __webpack_public_path__ + "img/xihuan-b.2c16d7ac.png";